<template>
  <div class="weather-charts">
    <div v-if="isEmpty" class="empty-view">
      <img src="/static/weather-no-data.png" class="empty-img"/>
    </div>
    <div v-if="!isEmpty">
      <!--气象图表-->
      <div class="weather-num-text-wrap" v-if="numText || isShowNumText">
        <div class="weather-num-text">
          <div v-if="numText">{{ numText }}</div>
          <div v-if="!numText" class="max-num">{{maxText}}：{{maxNum}}{{unitText}}</div>
          <div v-if="!numText" class="min-num">{{minText}}：{{minNum}}{{unitText}}</div>
          <div v-if="!numText" class="average-num">{{aveText}}：{{aveNum}}{{unitText}}</div>
        </div>
      </div>
      <div class="charts-inner" v-show="!isSunrise" ref="charts"></div>
      <!--日出日落-->
      <div v-show="isSunrise" class="sunrise">
        <img v-if="card.key == 105" src="/static/richu.jpg"/>
        <img v-if="card.key == 106" src="/static/riluo.jpg"/>
      </div>
      <div class="detail-text">{{ detailText }}</div>
    </div>
  </div>
</template>
<script>
  import echarts from 'echarts';
  import urlImg from '../../assets/images/c-arr.png'

  export default {
    props: ['deviceType'],
    data() {
      return {
        charts: null,
        isShowNumText: false,
        detailText: '',
        maxText: '',
        minText: '',
        aveText: '',
        unitText: '',
        numText: '',
        isEmpty: true,
        isSunrise: false,
        card: null,
        maxNum: 0, //最高
        minNum: 0, //最底
        aveNum: 0 //平均值
      };
    },
    methods: {
      seriesModel(name, data, rotateData) {
        const dataX = rotateData ? data.map((item, index) => {
          return {value: item, symbolRotate: 180 - rotateData[index]};
        }) : data;
        return {
          name, type: 'line', stack: '', data: dataX,
          smooth: true, showAllSymbol: true,
          itemStyle: {normal: {color: '#20d2ff', lineStyle: {color: '#20a0ff'}}}
        };
      },
      detailFill(detail) {
        if (detail.length > 0) {
          while (detail[0].CollectTime > 0) {
            const addItem = {CollectTime: (detail[0].CollectTime - 1) + ''};
            if (detail[0].Value1) {
              addItem.Value1 = 'null';
            }
            if (detail[0].Value2) {
              addItem.Value2 = 'null';
            }
            if (detail[0].Value3) {
              addItem.Value3 = 'null';
            }
            if (detail[0].Value4) {
              addItem.Value4 = 'null';
            }
            detail = [addItem].concat(detail);
          }
          while (detail[detail.length - 1].CollectTime < 23) {
            const lastItem = detail[detail.length - 1];
            const addItem = {CollectTime: (lastItem.CollectTime * 1 + 1) + ''};
            if (lastItem.Value1) {
              addItem.Value1 = 'null';
            }
            if (lastItem.Value2) {
              addItem.Value2 = 'null';
            }
            if (lastItem.Value3) {
              addItem.Value3 = 'null';
            }
            if (lastItem.Value4) {
              addItem.Value4 = 'null';
            }
            detail.push(addItem);
          }
        }
        return detail;
      },
      chartXName(key) {
        const titleMap = {
          1: '环境温度', 2: '环境湿度', 3: '风向', 4: '风速',
          5: '降水量', 6: '光照强度', 7: '土壤温度', 8: '土壤水分',
          9: '环境气压', 10: 'PH值', 11: '土壤盐分', 12: '蒸发量', 13: '二氧化碳',
          14: '光照辐射', 15: '氨气', 16: '硫化氢', 17: 'PM10',
          18: '日照时数', 19: '光合辐射',
          36: '土壤温度1', 37: '土壤温度2', 38: '土壤温度3', 39: '土壤温度4',
          40: '土壤湿度1', 41: '土壤湿度2', 42: '土壤湿度3', 43: '土壤湿度4',
          101: '空气温度', //墨迹
          102: '空气气压', //墨迹
          //103: '风向', //墨迹
          104: '风力风向', //墨迹
          105: '日出', //墨迹
          106: '日落', //墨迹
          107: '相对湿度', //墨迹
          108: '紫外线强度' //墨迹
        };
        const zaTitleMap = { //左岸
          1: '风力风向', 2: '风力风向', 3: '雨量',
          4: '空气温度', 5: '空气湿度', 6: '大气压力',
          7: '光照度', 8: 'PM2.5', 9: '土壤温度', 10: '土壤湿度',
          11: '土壤电导率', 12: '土壤镉离子'
        };
        if (this.deviceType == 2) {
          return zaTitleMap[key] || '';
        }
        return titleMap[key] || '';
      },
      detailTextMap(_key) {
        let key = _key;
        if (this.deviceType == 2) { //左岸
          if (key == 1 || key == 2) { //风力风向
            key = 4;
          } else if (key == 3) { //雨量(降水量)
            key = 5;
          } else if (key == 4) { //空气温度
            key = 101;
          } else if (key == 5) { //空气湿度
            key = 107;
          } else if (key == 6) { //大气压力
            return '';
          } else if (key == 7) { //光照度
            key = 6;
          } else if (key == 8) { //PM2.5
            return 'PM2.5：可吸入颗粒物，通常是指粒径在2.5微米以下的颗粒物;在环境空气中持续的时间很长，对人体健康和大气能见度的影响都很大。';
          } else if (key == 9) {//土壤温度
            key = 8;
          } else if (key == 10) {//土壤湿度
            key = 9;
          } else if (key == 11) {//土壤电导率
            key = 10;
          } else if (key == 12) {//土壤镉离子
            key = 11;
          } else {
            return '';
          }
        }
        if (key == 1) {
          return '温度：表示大气冷热程度的物理量，气象上给出的温度是指离地面1.5米高度上百叶箱中的空气温度。';
        } else if (key == 2) {
          return '相对湿度：空气中实际水气压与当时气温下的饱和水气压之比，以百分比（%）表示';
        } else if (key == 4) {
          return '风力风向：空气的水平运动，风力是风吹到物体上所表示出力量的大小，风向指风的来向';
        } else if (key == 5) {
          return '降水量：某一时段内的未经蒸发、渗透、流失的降水，在水平面上积累的深度，以毫米（mm）为单位。';
        } else if (key == 6) {
          return '光照强度，即通常所说的勒克司度（lux），表示被摄主体表面单位面积上受到的光通量,是衡量拍摄环境的一个重要指标。';
        } else if (key == 14) {
          return '光辐射：以电磁波形式或粒子（光子）形式传播的能量，他们可以用光学元件反射、成像或色散，这种能量及其传播过程称为光辐射,单位µmol';
        } else if (key == 10) {
          return '酸碱度描述的是水溶液的酸碱性强弱程度，用pH值来表示。热力学标准状况时，pH=7的水溶液呈中性，pH<7者显酸性，pH>7者显碱性。';
        } else if (key == 11) {
          return '土壤含盐量是土中所含盐分（主要是氯盐、硫酸盐、碳酸盐）的质量占干土质量的百分数。';
        } else if (key == 12) {
          return '蒸发量：是指在一定时段内，水分经蒸发而散布到空中的量，通常用蒸发掉的水层厚度以毫米（mm）为单位。';
        } else if (key == 13) {
          return '二氧化碳含量是指二氧化碳在空气中的百万分比（单位ppm），二氧化碳含量过高导致气温升高';
        } else if (key == 36) {
          return '土壤温度是指地面以下土壤中的温度，单位℃,绿色线表示土壤一层温度（距地表0~0.2m)，蓝色线表示土壤二层温度（距地表0.2-0.4m）,棕色线表示土壤三层温度（距地表0.4-0.6m），橙色线表示土壤四层温度（距地表0.6-0.8m）。';
        } else if (key == 40) {
          return '土壤湿度亦称土攘含水率，表示土壤干湿程度的物理量。绿色线表示土壤一层湿度（距地表0~0.2m)，蓝色线表示土壤二层湿度（距地表0.2-0.4m）,棕色线表示土壤三层湿度（距地表0.4-0.6m）,橙色线表示土壤四层湿度（距地表0.6-0.8m）。';
        } else if (key == 15) {
          return '氨气：NH3，无色气体，有强烈的刺激气味。能灼伤皮肤、眼睛、呼吸器官的粘膜，人吸入过多，能引起肺肿胀，以至死亡。';
        } else if (key == 16) {
          return '硫化氢：标准状况下是一种易燃的酸性气体，无色，低浓度时有臭鸡蛋气味，有毒，为易燃危化品。';
        } else if (key == 17) {
          return 'PM10：可吸入颗粒物，通常是指粒径在10微米以下的颗粒物;在环境空气中持续的时间很长，对人体健康和大气能见度的影响都很大。';
        } else if (key == 18) {
          return '日照时数：日出与日落之间的时间间隔。某地的日照时数和该地的地理位置与季节有关。';
        } else if (key == 19) {
          return '光合辐射：太阳辐射中对植物光合作用有效的光谱成分成为光合有效辐射，波长范围380～710纳米，与可见光基本重合。';
        } else if (key == 101) {
          return '温度：表示大气冷热程度的物理量，气象上给出的温度是指离地面1.5米高度上百叶箱中的空气温度。';
        } else if (key == 107) {
          return '相对湿度：空气中实际水气压与当时气温下的饱和水气压之比，以百分比（%）表示';
        } else if (key == 104) {
          return '风力风向：空气的水平运动，风力是风吹到物体上所表示出力量的大小，风向指风的来向';
        } else if (key == 108) {
        }
        return '';
      },
      levelDirectionWind(value) {
        let dir = '';
        if (value >= 0 && value <= 0.2) {
          dir = '静风';
        } else if (value >= 0.3 && value <= 1.5) {
          dir = '软风';
        } else if (value >= 1.6 && value <= 3.3) {
          dir = '轻风';
        } else if (value >= 3.4 && value <= 5.4) {
          dir = '微风';
        } else if (value >= 5.5 && value <= 7.9) {
          dir = '和风';
        } else if (value >= 8 && value <= 10.7) {
          dir = '清劲风';
        } else if (value >= 10.8 && value <= 13.8) {
          dir = '强风';
        } else if (value >= 13.9 && value <= 17.1) {
          dir = '疾风';
        } else if (value >= 17.2 && value <= 20.7) {
          dir = '大风';
        } else if (value >= 20.8 && value <= 24.4) {
          dir = '烈风';
        } else if (value >= 24.5 && value <= 28.4) {
          dir = '狂风';
        } else if (value >= 28.5 && value <= 32.6) {
          dir = '爆风';
        } else if (value >= 32.7 && value <= 36) {
          dir = '飓风';
        }
        return dir;
      },
      //风级转风描述
      levelDirectionWind2(value) {
        let dir = '';
        if (value < 1) {
          dir = '静风';
        } else if (value >= 1 && value <= 3) {
          dir = '软风';
        } else if (value >= 4 && value <= 6) {
          dir = '轻风';
        } else if (value >= 7 && value <= 10) {
          dir = '微风';
        } else if (value >= 11 && value <= 16) {
          dir = '和风';
        } else if (value >= 17 && value <= 21) {
          dir = '清劲风';
        } else if (value >= 22 && value <= 27) {
          dir = '强风';
        } else if (value >= 28 && value <= 33) {
          dir = '疾风';
        } else if (value >= 34 && value <= 40) {
          dir = '大风';
        } else if (value >= 41 && value <= 47) {
          dir = '烈风';
        } else if (value >= 48 && value <= 55) {
          dir = '狂风';
        } else if (value >= 56 && value <= 63) {
          dir = '爆风';
        } else if (value >= 64 && value <= 71) {
          dir = '飓风';
        }
        return dir;
      },
      windDirectionTran(value) {
        var dir = '';
        //value=value+90;
        if (value == 0) {
          dir = '北风';
        } else if (value < 30) {
          dir = '东北偏北风';
        } else if (value < 60) {
          dir = '东北风';
        } else if (value < 90) {
          dir = '东北偏东风';
        } else if (value == 90) {
          dir = '东风';
        } else if (value < 120) {
          dir = '东南偏东风';
        } else if (value < 150) {
          dir = '东南风';
        } else if (value < 180) {
          dir = '东南偏南风';
        } else if (value == 180) {
          dir = '南风';
        } else if (value < 210) {
          dir = '西南偏南风';
        } else if (value < 240) {
          dir = '西南风';
        } else if (value < 270) {
          dir = '西南偏西风';
        } else if (value == 270) {
          dir = '西风';
        } else if (value < 300) {
          dir = '西北偏西风';
        } else if (value < 330) {
          dir = '西北风';
        } else if (value < 360) {
          dir = '西北偏北风';
        } else if (value == 360) {
          dir = '北风';
        }
        return dir;
      },
      //风速转换风级
      windSpeedToLevel(sp) {
        var level = '--';
        if (sp < 0.2) {
          level = 0;
        } else if (sp < 1.5) {
          level = 1;
        } else if (sp < 3.3) {
          level = 2;
        } else if (sp < 5.4) {
          level = 3;
        } else if (sp < 7.9) {
          level = 4;
        } else if (sp < 10.7) {
          level = 5;
        } else if (sp < 13.8) {
          level = 6;
        } else if (sp < 17.1) {
          level = 7;
        } else if (sp < 20.7) {
          level = 8;
        } else if (sp < 24.4) {
          level = 9;
        } else if (sp < 28.4) {
          level = 10;
        } else if (sp < 32.6) {
          level = 11;
        } else if (sp < 36.9) {
          level = 12;
        }
        return level;
      },
      setNumsAndText(detail, card) {
        this.isShowNumText = true;
        let realDetails = [];
        const za = this.deviceType == '2';
        const flfx = za ? (card.key == 1 || card.key == 2) : (card.key == 4 || card.key == 104);
        if (flfx) {
          realDetails = detail.filter(item => item.Value2 !== 'null').map(item => {
            return {val: za ? item.Value1 : item.Value2};
          });
        } else {
          realDetails = detail.filter(item => item.Value1 !== 'null').map(item => {
            return {val: item.Value1};
          });
        }
        //-----
        let maxNum = null;
        let minNum = null;
        let sum = 0;
        realDetails.forEach((item, index) => {
          const val = item.val * 1;
          if (index == 0) {
            maxNum = val;
            minNum = val;
          } else {
            if (val > maxNum) {
              maxNum = val;
            }
            if (val < minNum) {
              minNum = val;
            }
          }
          sum += val;
        });
        this.maxNum = maxNum;
        this.minNum = minNum;
        this.aveNum = (sum / realDetails.length).toFixed(2) * 1;
        //-----
        this.maxText = '';
        this.minText = '';
        this.aveText = '';
        this.unitText = '';
        const qiwen = za ? (card.key == 4) : (card.key == 1);
        const shidu = za ? (card.key == 5) : (card.key == 2);
        const fenli = za ? (card.key == 1) : (card.key == 4);
        const jiangshui = za ? (card.key == 3) : (card.key == 5);
        const qiya = za ? (card.key == 6) : (card.key == 9);
        const guangzhao = za ? (card.key == 7) : (card.key == 6);
        const pm = za ? (card.key == 8) : (card.key == 17);
        if (qiwen) {
          this.maxText = '最高气温';
          this.minText = '最低气温';
          this.aveText = '平均气温';
          this.unitText = '℃';
        } else if (shidu) {
          this.maxText = '最高相对湿度';
          this.minText = '最低相对湿度';
          this.aveText = '平均相对湿度';
          this.unitText = '%';
        } else if (fenli) {
          this.maxText = '最高风力';
          this.minText = '最低风力';
          this.aveText = '平均风力';
          this.unitText = 'm/s';
        } else if (jiangshui) {
          this.maxText = '最高降水量';
          this.minText = '最低降水量';
          this.aveText = '平均降水量';
          this.unitText = 'mm';
        } else if (guangzhao) {
          this.maxText = '最高光照强度';
          this.minText = '最低光照强度';
          this.aveText = '平均光照强度';
          this.unitText = 'lux';
        } else if (qiya) {
          this.maxText = '最高环境气压';
          this.minText = '最低环境气压';
          this.aveText = '平均环境气压';
          this.unitText = 'hpa';
        } else if (card.key == 14) {
          this.maxText = '最高光照辐射';
          this.minText = '最低光照辐射';
          this.aveText = '平均光照辐射';
          this.unitText = 'µmol';
        } else if (card.key == 10) {
          this.maxText = '最高PH值';
          this.minText = '最低PH值';
          this.aveText = '平均PH值';
          this.unitText = '';
        } else if (card.key == 11) {
          this.maxText = '最高土壤盐含量';
          this.minText = '最低土壤盐含量';
          this.aveText = '平均土壤盐含量';
          this.unitText = '%';
        } else if (card.key == 12) {
          this.maxText = '最高蒸发量';
          this.minText = '最低蒸发量';
          this.aveText = '平均蒸发量';
          this.unitText = 'mm';
        } else if (card.key == 13) {
          this.maxText = '最高二氧化碳含量';
          this.minText = '最低二氧化碳含量';
          this.aveText = '平均二氧化碳含量';
          this.unitText = 'ppm';
        } else if (card.key == 36) {
          this.maxText = '';
          this.minText = '';
          this.aveText = '';
          this.unitText = '℃';
          this.isShowNumText = false;
        } else if (card.key == 40) {
          this.maxText = '';
          this.minText = '';
          this.aveText = '';
          this.unitText = '%';
          this.isShowNumText = false;
        } else if (card.key == 15) {
          this.maxText = '最高氨气含量';
          this.minText = '最低氨气含量';
          this.aveText = '平均氨气含量';
          this.unitText = 'ppb';
        } else if (card.key == 16) {
          this.maxText = '最高硫化氢含量';
          this.minText = '最低硫化氢含量';
          this.aveText = '平均硫化氢含量';
          this.unitText = 'ppb';
        } else if (pm) {
          this.maxText = '最高PH10值';
          this.minText = '最低PH10值';
          this.aveText = '平均PM10值';
          this.unitText = 'ug/m2';
          if (za) {
            this.maxText = '最高PH2.5值';
            this.minText = '最低PH2.5值';
            this.aveText = '平均PH2.5值';
            this.unitText = 'ug/m3';
          }
        } else if (card.key == 18) {
          this.maxText = '最高日照时数';
          this.minText = '最低日照时数';
          this.aveText = '平均日照时数';
          this.unitText = 'min';
        } else if (card.key == 19) {
          this.maxText = '最高光合辐射';
          this.minText = '最低光合辐射';
          this.aveText = '平均光合辐射';
          this.unitText = 'μmol/㎡/s';
        } else if (card.key == 101) {
          this.maxText = '最高气温';
          this.minText = '最低气温';
          this.aveText = '平均气温';
          this.unitText = '℃';
        } else if (card.key == 107) {
          this.maxText = '最高相对湿度';
          this.minText = '最低相对湿度';
          this.aveText = '平均相对湿度';
          this.unitText = '%';
        } else if (card.key == 104) {
          this.maxText = '最高风力';
          this.minText = '最低风力';
          this.aveText = '平均风力';
          this.unitText = '级';
        } else if (card.key == 108) {
          this.maxText = '';
          this.minText = '';
          this.aveText = '';
          this.unitText = 'µmol';
          this.isShowNumText = false;
        } else {
          this.isShowNumText = false;
        }
      },
      renderCard36(card, detail) { //土壤温度
        const soilItem = ['温度一层', '温度二层', '温度三层', '温度四层'];
        const weaHours = [];
        const data0 = [];
        const data1 = [];
        const data2 = [];
        const data3 = [];
        for (let i = 0; i < 24; i++) {
          weaHours.push(i);
          data0[i] = null;
          data1[i] = null;
          data2[i] = null;
          data3[i] = null;
        }
        detail.forEach(item => {
          const time = item.CollectTime * 1;
          data0[time] = (item.Value1 * 1) || '-';
          data1[time] = (item.Value2 * 1) || '-';
          data2[time] = (item.Value3 * 1) || '-';
          data3[time] = (item.Value4 * 1) || '-';
        });
        const option = {
          color: '#f38428',
          tooltip: {trigger: 'axis', axisPointer: {label: {backgroundColor: '#6a7985'}}},
          legend: {data: soilItem},
          toolbox: {feature: {}},
          grid: {left: '3%', right: '7%', bottom: '3%', containLabel: true, borderColor: '#eaeaea'},
          xAxis: [{type: 'category', boundaryGap: false, data: weaHours, name: 'h'}],
          yAxis: [{type: 'value', name: '℃'}],
          series: [
            {
              name: soilItem[0], type: 'line', symbol: 'circle',
              itemStyle: {normal: {color: '#93d470', borderWidth: 5}},
              lineStyle: {normal: {color: '#93d470', width: 2, type: 'solid'}},
              data: data0
            },
            {
              name: soilItem[1], type: 'line', symbol: 'circle',
              itemStyle: {normal: {color: '#71cbff', borderWidth: 5}},
              lineStyle: {normal: {color: '#71cbff', width: 2, type: 'solid'}},
              data: data1
            },
            {
              name: soilItem[2], type: 'line', symbol: 'circle',
              itemStyle: {normal: {color: '#cb9349', borderWidth: 5}},
              lineStyle: {normal: {color: '#cb9349', width: 2, type: 'solid'}},
              data: data2
            },
            {
              name: soilItem[3], type: 'line', symbol: 'circle',
              itemStyle: {normal: {color: '#fec248', borderWidth: 5}},
              lineStyle: {normal: {color: '#fec248', width: 2, type: 'solid'}},
              data: data3
            }
          ]
        };
        if (this.charts) {
          this.charts.dispose();
          this.charts = null;
        }
        this.charts = echarts.init(this.$refs.charts);
        this.charts.setOption(option);
      },
      renderCard40(card, detail) { //土壤湿度
        const soilItem = ['湿度一层', '湿度二层', '湿度三层', '湿度四层'];
        const weaHours = [];
        const data0 = [];
        const data1 = [];
        const data2 = [];
        const data3 = [];
        for (let i = 0; i < 24; i++) {
          weaHours.push(i);
          data0[i] = null;
          data1[i] = null;
          data2[i] = null;
          data3[i] = null;
        }
        detail.forEach(item => {
          const time = item.CollectTime * 1;
          data0[time] = (item.Value1 * 1) || '-';
          data1[time] = (item.Value2 * 1) || '-';
          data2[time] = (item.Value3 * 1) || '-';
          data3[time] = (item.Value4 * 1) || '-';
        });
        const option = {
          color: '#f38428',
          tooltip: {trigger: 'axis', axisPointer: {label: {backgroundColor: '#6a7985'}}},
          legend: {data: soilItem},
          toolbox: {feature: {}},
          grid: {left: '3%', right: '7%', bottom: '3%', containLabel: true, borderColor: '#eaeaea'},
          xAxis: [{type: 'category', boundaryGap: false, data: weaHours, name: 'h'}],
          yAxis: [{type: 'value', name: '%'}],
          series: [
            {
              name: soilItem[0], type: 'line', symbol: 'circle',
              itemStyle: {normal: {color: '#93d470', borderWidth: 5}},
              lineStyle: {normal: {color: '#93d470', width: 2, type: 'solid'}},
              data: data0
            },
            {
              name: soilItem[1], type: 'line', symbol: 'circle',
              itemStyle: {normal: {color: '#71cbff', borderWidth: 5}},
              lineStyle: {normal: {color: '#71cbff', width: 2, type: 'solid'}},
              data: data1
            },
            {
              name: soilItem[2], type: 'line', symbol: 'circle',
              itemStyle: {normal: {color: '#cb9349', borderWidth: 5}},
              lineStyle: {normal: {color: '#cb9349', width: 2, type: 'solid'}},
              data: data2
            },
            {
              name: soilItem[3], type: 'line', symbol: 'circle',
              itemStyle: {normal: {color: '#fec248', borderWidth: 5}},
              lineStyle: {normal: {color: '#fec248', width: 2, type: 'solid'}},
              data: data3
            }
          ]
        };
        if (this.charts) {
          this.charts.dispose();
          this.charts = null;
        }
        this.charts = echarts.init(this.$refs.charts);
        this.charts.setOption(option);
      },
      async render(card, stationID, token) {
        //console.log(card, stationID);
        const za = this.deviceType == '2';
        this.card = card;
        let detail = await this.loadDetail(card.key, stationID, token);
        this.isEmpty = false;
        if (detail === null) {
          this.isEmpty = true;
          return;
        }
        if (card.key == 105 || card.key == 106) {
          this.isSunrise = true;
        } else {
          this.isSunrise = false;
        }
        await this.$nextTick();
        this.setNumsAndText(detail, card);
        if (card.key == 36) {
          this.renderCard36(card, detail);
          this.detailText = this.detailTextMap(card.key);
          return;
        } else if (card.key == 40) {
          this.renderCard40(card, detail);
          this.detailText = this.detailTextMap(card.key);
          return;
        }
        detail = this.detailFill(detail);
        const xData = detail.map(item => item.CollectTime);
        const series = [];
        const xname = this.chartXName(card.key);
        this.detailText = this.detailTextMap(card.key);
        const flfx = za ? (card.key == 1 || card.key == 2) : (card.key == 4 || card.key == 104);
        if (flfx) { //风力风向
          let data = detail.map(item => {
            return item.Value2 * 1;
          });
          let rotateData = detail.map(item => {
            return item.Value1 * 1;
          });
          if (za) {
            data = detail.map(item => {
              return item.Value1 * 1;
            });
            rotateData = detail.map(item => {
              return item.Value2 * 1;
            });
          }
          const series1 = this.seriesModel(xname, data, rotateData);
          series1.symbol = 'image://' + urlImg;
          series1.symbolSize = 14;
          series.push(series1);
        } else if (detail[0].Value1) {
          const data = detail.map(item => {
            if (card.key == 105 || card.key == 106) {
              return 6;
            }
            return item.Value1 * 1;
          });
          const series1 = this.seriesModel(xname, data);
          series.push(series1);
        }
        const option = {
          tooltip: {
            trigger: 'axis', formatter: (params) => {
              const res = params.map(param => {
                if (card.key == 105 || card.key == 106) {
                  return `${param.seriesName}：${card.value}`;
                }
                return param.data ? `${param.seriesName}：${param.data}${this.unitText}` : '';
              });
              return res.join('<br/>');
            }
          },
          grid: {left: '3%', right: '7%', bottom: '3%', containLabel: true},
          xAxis: {type: 'category', boundaryGap: false, data: xData, name: 'h'},
          yAxis: {type: 'value', name: this.unitText},
          series: series
        };
        if (flfx) {
          option.tooltip.formatter = (params) => {
            let val = detail[params[0].dataIndex].Value1;
            let name = card.key == 4 ? this.levelDirectionWind(params[0].value) : this.levelDirectionWind2(params[0].value);
            let fx = this.windDirectionTran(val);
            let value = params[0].value;
            let level = (card.key == 4 ? this.windSpeedToLevel(value) : value) + '级';
            if (za) {
              const val2 = detail[params[0].dataIndex].Value2;
              name = this.levelDirectionWind(val);
              fx = this.windDirectionTran(val2);
              value = val;
              level = this.windSpeedToLevel(value) + '级';
            }
            if (card.key == 4) {
              return `名称:${name}<br/>风向:${fx}<br/>风力:${value}m/s<br/>风级:${level}`;
            } else {
              return `名称:${name}<br/>风向:${fx}<br/>风级:${level}`;
            }
          };
        }
        //日出日落
        this.numText = '';
        if (card.key == 105 || card.key == 106) {
          this.numText = card.key == 105 ? ('日出：' + card.value) : ('日落：' + card.value);
          option.yAxis.max = 12;
          option.yAxis.axisLabel = {
            formatter: (param) => {
              return '';
            }
          };
        }
        if (this.charts) {
          this.charts.dispose();
          this.charts = null;
        }
        this.charts = echarts.init(this.$refs.charts);
        this.charts.setOption(option);
      },
      async loadDetail(Type, StationID, Token) {
        const params = {Type, StationID, Token};
        //console.log(this.deviceType);
        if (this.deviceType == '2') { //左岸
          //params.DateWeather = '2018-12-18';
        }
        const result = await this.$ajax.jsonp(this.$urlAPI.BaseData.GetWeatherAllDayInfoByType, params);
        if (result.Result == 200 && result.Data && result.Data.RecordList) {
          return result.Data.RecordList;
        }
        return null;
      }
    }
  }
</script>
<style rel="stylesheet/less" lang="less" scoped>
  .weather-charts {
    position: relative;
    height: 100%;
  }

  .charts-inner {
    position: absolute;
    width: 96%;
    height: 75%;
    left: 2%;
    top: 35px;
  }

  .detail-text {
    position: absolute;
    font-size: 12px;
    color: #8d8d8d;
    left: 2%;
    top: ~'calc(75% + 45px)';
    width: 96%;
    text-align: center;
  }

  .weather-num-text-wrap {
    position: absolute;
    font-size: 12px;
    color: #ffffff;
    text-align: center;
    width: 100%;
    top: 10px;
    .weather-num-text {
      display: inline-block;
      height: 24px;
      line-height: 24px;
      background-color: #c1c1c1;
      padding: 0 5px;
      border-radius: 5px;
      .max-num, .min-num, .average-num {
        display: inline-block;
        vertical-align: top;
      }
    }
  }

  .empty-view {
    text-align: center;
    position: relative;
    height: 100%;
    .empty-img {
      position: absolute;
      left: 50%;
      top: 50%;
      width: 176px;
      height: 180px;
      margin-left: -88px;
      margin-top: -90px;
    }
  }

  .sunrise {
    position: absolute;
    width: 96%;
    height: 85%;
    left: 2%;
    top: 35px;
    img {
      position: absolute;
      width: 100%;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
    }
  }
</style>



// WEBPACK FOOTER //
// weather-charts.vue?025d0d5c